import { useCallback, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

// Highlight the row a link points at (e.g. from a notification): the row
// whose id is in the URL (?highlight=… by default) is scrolled into view
// once it renders and tinted, the same yellow the Intake Queue uses.
export function useRowHighlight(param = 'highlight') {
  const [searchParams] = useSearchParams();
  const highlightId = searchParams.get(param);
  const scrolledTo = useRef<string | null>(null);

  const rowRef = useCallback((rowId: string) => (el: HTMLElement | null) => {
    if (!el || rowId !== highlightId || scrolledTo.current === highlightId) return;
    scrolledTo.current = highlightId;
    requestAnimationFrame(() => el.scrollIntoView({ block: 'center', behavior: 'smooth' }));
  }, [highlightId]);

  const highlightClass = useCallback((rowId: string) => (rowId === highlightId ? 'bg-[#FFF7D6]' : ''), [highlightId]);

  return { highlightId, rowRef, highlightClass };
}
